import sha1 from 'crypto-js/sha1';
import { apiPost, apiGet, getHostApi, hasPermission } from './apiWrapper';
import { isNullOrUndefined } from './storeFunctions';
import { formatDate } from 'react-day-picker/moment';

const initCeeSearchType = "INIT_CEE_SEARCH";
const loadSearchFormType = "REGISTRY_FORM_LOADED";
const leavingSearchFormType = "REGISTRY_FORM_LEAVING";
const loadPrefilledData = "REGISTRY_PREFILLED_DATA_REQUEST";
const failPrefilledData = "REGISTRY_PREFILLED_DATA_REQUEST_FAIL";
const successPrefilledData = "REGISTRY_PREFILLED_DATA_REQUEST_SUCCESS";
const initiateType = "INITIATE_REGISTRY_REQUEST";
const failType = "RECEIVE_REGISTRY_REQUEST_FAIL";
const successType = "RECEIVE_REGISTRY_REQUEST_SUCCESS";
const setResultsRequestParamsType = "SET_RESULTS_REQUEST_PARAMS";
const registryErrorType = "REGISTRY_ERROR";

export const REGISTRY = {
    cee: "cee",
    cre: "cre",
    aml: "aml",
    rpve: "rpve"
};

export const SEARCH_TYPE = {
    fo: "fo",
    fpo: "fpo",
    po: "po",
    bulk: "bulk",
    trialFile: "trial-file"
}

const sectionInitialState = {
    isRequesting: false,
    requestResult: null,
    isFormRendered: false,
    isPrefilledDataLoaded: true,
    responseData: null,
    settings: {},
    prefilledData: null,
    resultsRequestParams: null,
};

const initialState = {
    [REGISTRY.cee]: { ...sectionInitialState },
    [REGISTRY.cre]: { ...sectionInitialState },
    [REGISTRY.aml]: { ...sectionInitialState },
    [REGISTRY.rpve]: { ...sectionInitialState },
    registryError: false
}

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case initCeeSearchType:
            return { ...state, registryError: false, [action.registry]: { ...sectionInitialState } };
        case loadSearchFormType:
            return { ...state, registryError: false, [action.registry]: { ...state[action.registry], isFormRendered: true, settings: action.settings } };
        case leavingSearchFormType:
            return { ...state, registryError: false, [action.registry]: { ...sectionInitialState, isFormRendered: false } };
        case loadPrefilledData:
            return { ...state, registryError: false, [action.registry]: { ...state[action.registry], isPrefilledDataLoaded: false, prefilledData: null } };
        case failPrefilledData:
            return { ...state, registryError: false, [action.registry]: { ...state[action.registry], isPrefilledDataLoaded: true, prefilledData: null } };
        case successPrefilledData:
            return { ...state, registryError: false, [action.registry]: { ...state[action.registry], isPrefilledDataLoaded: true, prefilledData: action.data } };
        case initiateType:
            return { ...state, registryError: false, [action.registry]: { ...state[action.registry], isRequesting: true, requestResult: null } };
        case failType:
            return { ...state, registryError: false, [action.registry]: { ...state[action.registry], isRequesting: false, requestResult: false,
                responseData: isNullOrUndefined(action.data) ? null : action.data.data } };
        case successType:
            const data = isNullOrUndefined(action.data) || isNullOrUndefined(action.data.data) ? null : action.data.data;
            return { ...state, registryError: false, [action.registry]: { ...state[action.registry], isRequesting: false,
                requestResult: isNullOrUndefined(data) || isNullOrUndefined(data.isSuccess) ? true : data.isSuccess,
                responseData: data } };
        case setResultsRequestParamsType:
            return { ...state, registryError: false, [action.registry]: { ...state[action.registry], resultsRequestParams: action.params } };
        case registryErrorType:
            return { ...state, registryError: true };
        default: return state;
    }
}

function getUrl(registry, subjectType) { return `${getHostApi()}/api/search/${registry}/${subjectType}`; }

function initCeeSearch(registry, dispatch) {
    dispatch({ type: initCeeSearchType, registry: registry });
}

function searchFormLoaded(registry, dispatch) {
    apiGet(`${getHostApi()}/api/account/settings`, null,
        (s) => {
            let settings = {};
            if (!isNullOrUndefined(s.data))
                Object.keys(s.data).filter(f => f.startsWith(registry)).forEach(k => settings[k] = s.data[k]);
            dispatch({ type: loadSearchFormType, registry: registry, settings: settings });
        },
        (_) => dispatch({ type: loadSearchFormType, registry: registry, settings: {} })
    )
}

function searchFormLeaving(registry, dispatch) {
    dispatch({ type: leavingSearchFormType, registry: registry });
}

function getPrefilledData(registry, params, dispatch) {
    dispatch({ type: loadPrefilledData, registry: registry });
    apiGet(`${window.babylonApiUrl}/api/search/${registry}/prefilled-data`, params,
        (response) => {
            if (response.data.dob)
                response.data.dob = formatDate(response.data.dob, 'YYYY-MM-DD', 'cs');
            dispatch({ type: successPrefilledData, registry: registry, data: response.data })
        },
        () => dispatch({ type: failPrefilledData, registry: registry })        
    );
}

function setResultsRequestParams(registry, params, dispatch) {
    dispatch({ type: setResultsRequestParamsType, registry: registry, params: params })
}

//TODO Adam - refactor -> remove subRegistry
function initiateCeeRequest(data, registry, subRegistry, subjectType, dispatch, getState) {
    const regState = getState().registrySearch[registry];
    if (isNullOrUndefined(regState))
        dispatch({ type: registryErrorType });
    else if (regState.isRequesting === false) {
        dispatch({ type: initiateType, registry: registry });
        apiPost(getUrl(subRegistry, subjectType), null, data,
            response => dispatch({ type: successType, registry: registry, data: response }),
            response => dispatch({ type: failType, registry: registry, data: response })
        );
    }
}

function exportPdf(registry, getState) {
    const params = getState().registrySearch[registry].resultsRequestParams;

    if (!isNullOrUndefined(params)) {
        apiPost(`${getHostApi()}/api/search/${registry}/${params.subPath}/${params.id}/pdf-export`, params.params, null);
    }
}

export const registrySearchActions = {
    initCeeSearch: (registry) => dispatch => initCeeSearch(registry, dispatch),
    initiateCeeRequestOnFo: (registry, subRegistry, data) => async (dispatch, getState) => initiateCeeRequest(data, registry, subRegistry, 'fo', dispatch, getState),
    initiateCeeRequestOnPo: (registry, subRegistry, data, isOnPath = false) => async (dispatch, getState) => initiateCeeRequest(data, registry, subRegistry, isOnPath ? 'path' : 'po', dispatch, getState),
    initiateCeeRequestOnFpo: (registry, subRegistry, data) => async (dispatch, getState) => initiateCeeRequest(data, registry, subRegistry, 'fpo', dispatch, getState),
    initiateCeeRequestBulk: (registry, subRegistry, data) => async (dispatch, getState) => initiateCeeRequest(data, registry, subRegistry, 'bulk', dispatch, getState),
    initiateCeeRequestOnTrialFile: (registry, subRegistry, data) => async (dispatch, getState) => initiateCeeRequest(data, registry, subRegistry, 'trial-file', dispatch, getState),
    searchFormLoaded: (registry) => dispatch => searchFormLoaded(registry, dispatch),
    searchFormLeaving: (registry) => dispatch => searchFormLeaving(registry, dispatch),
    getPrefilledData: (registry, params) => dispatch => getPrefilledData(registry, params, dispatch),
    setResultsRequestParams: (registry, params) => dispatch => setResultsRequestParams(registry, params, dispatch),
    exportPdf: (registry) => async (dispatch, getState) => exportPdf(registry, getState)
}

export const switchPerm = (registry, cee, cre, aml, rpve) => {
    switch (registry) {
        case REGISTRY.cee: return cee;
        case REGISTRY.cre: return cre;
        case REGISTRY.aml: return aml;
        case REGISTRY.rpve: return rpve;

        default: return null;
    }
}
export const checkPerm = (registry, cee, cre, aml, rpve) => {
    return hasPermission(null, switchPerm(registry, cee, cre, aml, rpve));
};
export const getDataHash = (data) => {
    return sha1(JSON.stringify(data)).toString().toUpperCase()
}